import { render, staticRenderFns } from "./CopyRight_2.vue?vue&type=template&id=3e36a8e4&scoped=true&"
import script from "./CopyRight_2.vue?vue&type=script&lang=js&"
export * from "./CopyRight_2.vue?vue&type=script&lang=js&"
import style0 from "./CopyRight_2.vue?vue&type=style&index=0&id=3e36a8e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e36a8e4",
  null
  
)

export default component.exports